import { AbstractPlugin as O } from "./ghl-ui.es794.js";
import { MirrorCreateEvent as A, MirrorCreatedEvent as T, MirrorAttachedEvent as D, MirrorMoveEvent as P, MirrorDestroyEvent as $, MirrorMovedEvent as E } from "./ghl-ui.es373.js";
const u = Symbol("onDragStart"), g = Symbol("onDragMove"), p = Symbol("onDragStop"), M = Symbol("onMirrorCreated"), y = Symbol("onMirrorMove"), m = Symbol("onScroll"), S = Symbol("getAppendableContainer"), L = {
  constrainDimensions: !1,
  xAxis: !0,
  yAxis: !0,
  cursorOffsetX: null,
  cursorOffsetY: null,
  thresholdX: null,
  thresholdY: null
};
class z extends O {
  constructor(t) {
    super(t), this.options = {
      ...L,
      ...this.getOptions()
    }, this.scrollOffset = {
      x: 0,
      y: 0
    }, this.initialScrollOffset = {
      x: window.scrollX,
      y: window.scrollY
    }, this[u] = this[u].bind(this), this[g] = this[g].bind(this), this[p] = this[p].bind(this), this[M] = this[M].bind(this), this[y] = this[y].bind(this), this[m] = this[m].bind(this);
  }
  attach() {
    this.draggable.on("drag:start", this[u]).on("drag:move", this[g]).on("drag:stop", this[p]).on("mirror:created", this[M]).on("mirror:move", this[y]);
  }
  detach() {
    this.draggable.off("drag:start", this[u]).off("drag:move", this[g]).off("drag:stop", this[p]).off("mirror:created", this[M]).off("mirror:move", this[y]);
  }
  getOptions() {
    return this.draggable.options.mirror || {};
  }
  [u](t) {
    if (t.canceled())
      return;
    "ontouchstart" in window && document.addEventListener("scroll", this[m], !0), this.initialScrollOffset = {
      x: window.scrollX,
      y: window.scrollY
    };
    const {
      source: e,
      originalSource: i,
      sourceContainer: o,
      sensorEvent: r
    } = t;
    this.lastMirrorMovedClient = {
      x: r.clientX,
      y: r.clientY
    };
    const n = new A({
      source: e,
      originalSource: i,
      sourceContainer: o,
      sensorEvent: r,
      dragEvent: t
    });
    if (this.draggable.trigger(n), B(r) || n.canceled())
      return;
    const a = this[S](e) || o;
    this.mirror = e.cloneNode(!0);
    const l = new T({
      source: e,
      originalSource: i,
      sourceContainer: o,
      sensorEvent: r,
      dragEvent: t,
      mirror: this.mirror
    }), h = new D({
      source: e,
      originalSource: i,
      sourceContainer: o,
      sensorEvent: r,
      dragEvent: t,
      mirror: this.mirror
    });
    this.draggable.trigger(l), a.appendChild(this.mirror), this.draggable.trigger(h);
  }
  [g](t) {
    if (!this.mirror || t.canceled())
      return;
    const {
      source: e,
      originalSource: i,
      sourceContainer: o,
      sensorEvent: r
    } = t;
    let n = !0, a = !0;
    if (this.options.thresholdX || this.options.thresholdY) {
      const {
        x: h,
        y: d
      } = this.lastMirrorMovedClient;
      if (Math.abs(h - r.clientX) < this.options.thresholdX ? n = !1 : this.lastMirrorMovedClient.x = r.clientX, Math.abs(d - r.clientY) < this.options.thresholdY ? a = !1 : this.lastMirrorMovedClient.y = r.clientY, !n && !a)
        return;
    }
    const l = new P({
      source: e,
      originalSource: i,
      sourceContainer: o,
      sensorEvent: r,
      dragEvent: t,
      mirror: this.mirror,
      passedThreshX: n,
      passedThreshY: a
    });
    this.draggable.trigger(l);
  }
  [p](t) {
    if ("ontouchstart" in window && document.removeEventListener("scroll", this[m], !0), this.initialScrollOffset = {
      x: 0,
      y: 0
    }, this.scrollOffset = {
      x: 0,
      y: 0
    }, !this.mirror)
      return;
    const {
      source: e,
      sourceContainer: i,
      sensorEvent: o
    } = t, r = new $({
      source: e,
      mirror: this.mirror,
      sourceContainer: i,
      sensorEvent: o,
      dragEvent: t
    });
    this.draggable.trigger(r), r.canceled() || this.mirror.remove();
  }
  [m]() {
    this.scrollOffset = {
      x: window.scrollX - this.initialScrollOffset.x,
      y: window.scrollY - this.initialScrollOffset.y
    };
  }
  [M]({
    mirror: t,
    source: e,
    sensorEvent: i
  }) {
    const o = this.draggable.getClassNamesFor("mirror"), r = ({
      mirrorOffset: a,
      initialX: l,
      initialY: h,
      ...d
    }) => (this.mirrorOffset = a, this.initialX = l, this.initialY = h, this.lastMovedX = l, this.lastMovedY = h, {
      mirrorOffset: a,
      initialX: l,
      initialY: h,
      ...d
    });
    t.style.display = "none";
    const n = {
      mirror: t,
      source: e,
      sensorEvent: i,
      mirrorClasses: o,
      scrollOffset: this.scrollOffset,
      options: this.options,
      passedThreshX: !0,
      passedThreshY: !0
    };
    return Promise.resolve(n).then(N).then(q).then(F).then(H).then(b({
      initial: !0
    })).then(V).then(r);
  }
  [y](t) {
    if (t.canceled())
      return null;
    const e = ({
      lastMovedX: r,
      lastMovedY: n,
      ...a
    }) => (this.lastMovedX = r, this.lastMovedY = n, {
      lastMovedX: r,
      lastMovedY: n,
      ...a
    }), i = (r) => {
      const n = new E({
        source: t.source,
        originalSource: t.originalSource,
        sourceContainer: t.sourceContainer,
        sensorEvent: t.sensorEvent,
        dragEvent: t.dragEvent,
        mirror: this.mirror,
        passedThreshX: t.passedThreshX,
        passedThreshY: t.passedThreshY
      });
      return this.draggable.trigger(n), r;
    }, o = {
      mirror: t.mirror,
      sensorEvent: t.sensorEvent,
      mirrorOffset: this.mirrorOffset,
      options: this.options,
      initialX: this.initialX,
      initialY: this.initialY,
      scrollOffset: this.scrollOffset,
      passedThreshX: t.passedThreshX,
      passedThreshY: t.passedThreshY,
      lastMovedX: this.lastMovedX,
      lastMovedY: this.lastMovedY
    };
    return Promise.resolve(o).then(b({
      raf: !0
    })).then(e).then(i);
  }
  [S](t) {
    const e = this.options.appendTo;
    return typeof e == "string" ? document.querySelector(e) : e instanceof HTMLElement ? e : typeof e == "function" ? e(t) : t.parentNode;
  }
}
function N({
  source: s,
  ...t
}) {
  return c((e) => {
    const i = s.getBoundingClientRect();
    e({
      source: s,
      sourceRect: i,
      ...t
    });
  });
}
function q({
  sensorEvent: s,
  sourceRect: t,
  options: e,
  ...i
}) {
  return c((o) => {
    const r = e.cursorOffsetY === null ? s.clientY - t.top : e.cursorOffsetY, n = e.cursorOffsetX === null ? s.clientX - t.left : e.cursorOffsetX;
    o({
      sensorEvent: s,
      sourceRect: t,
      mirrorOffset: {
        top: r,
        left: n
      },
      options: e,
      ...i
    });
  });
}
function F({
  mirror: s,
  source: t,
  options: e,
  ...i
}) {
  return c((o) => {
    let r, n;
    if (e.constrainDimensions) {
      const a = getComputedStyle(t);
      r = a.getPropertyValue("height"), n = a.getPropertyValue("width");
    }
    s.style.display = null, s.style.position = "fixed", s.style.pointerEvents = "none", s.style.top = 0, s.style.left = 0, s.style.margin = 0, e.constrainDimensions && (s.style.height = r, s.style.width = n), o({
      mirror: s,
      source: t,
      options: e,
      ...i
    });
  });
}
function H({
  mirror: s,
  mirrorClasses: t,
  ...e
}) {
  return c((i) => {
    s.classList.add(...t), i({
      mirror: s,
      mirrorClasses: t,
      ...e
    });
  });
}
function V({
  mirror: s,
  ...t
}) {
  return c((e) => {
    s.removeAttribute("id"), delete s.id, e({
      mirror: s,
      ...t
    });
  });
}
function b({
  withFrame: s = !1,
  initial: t = !1
} = {}) {
  return ({
    mirror: e,
    sensorEvent: i,
    mirrorOffset: o,
    initialY: r,
    initialX: n,
    scrollOffset: a,
    options: l,
    passedThreshX: h,
    passedThreshY: d,
    lastMovedX: X,
    lastMovedY: Y,
    ...w
  }) => c((C) => {
    const f = {
      mirror: e,
      sensorEvent: i,
      mirrorOffset: o,
      options: l,
      ...w
    };
    if (o) {
      const v = h ? Math.round((i.clientX - o.left - a.x) / (l.thresholdX || 1)) * (l.thresholdX || 1) : Math.round(X), x = d ? Math.round((i.clientY - o.top - a.y) / (l.thresholdY || 1)) * (l.thresholdY || 1) : Math.round(Y);
      l.xAxis && l.yAxis || t ? e.style.transform = `translate3d(${v}px, ${x}px, 0)` : l.xAxis && !l.yAxis ? e.style.transform = `translate3d(${v}px, ${r}px, 0)` : l.yAxis && !l.xAxis && (e.style.transform = `translate3d(${n}px, ${x}px, 0)`), t && (f.initialX = v, f.initialY = x), f.lastMovedX = v, f.lastMovedY = x;
    }
    C(f);
  }, {
    frame: s
  });
}
function c(s, {
  raf: t = !1
} = {}) {
  return new Promise((e, i) => {
    t ? requestAnimationFrame(() => {
      s(e, i);
    }) : s(e, i);
  });
}
function B(s) {
  return /^drag/.test(s.originalEvent.type);
}
export {
  z as default,
  L as defaultOptions,
  S as getAppendableContainer,
  g as onDragMove,
  u as onDragStart,
  p as onDragStop,
  M as onMirrorCreated,
  y as onMirrorMove,
  m as onScroll
};
